import './polyfill'
import React from "react";
import ReactDOM from "react-dom";
import "rest-css";
import "antd-mobile/dist/antd-mobile.css";
import "./scss/index.scss";
import Router from "./router";
ReactDOM.render(<Router />, document.getElementById("root"));
